import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PIC } from "@ryde/assets";
import { MuiButton } from "@ryde/controls";
import {
  DrawerType,
  RoutePaths,
  useDrawers,
  useIsMobile,
  usePrefixedRouting,
} from "@ryde/shared";

import { LayoutRightHeaderTitleStyled } from "../../../right";
import { DrawerCloseIconButton } from "../drawer";
import { NotificationStats } from "./components";
import { NotificationHeaderStyled } from "./notification-header.styled";

interface INotificationHeaderProps {
  onClose: () => void;
}

export const NotificationHeader: FC<INotificationHeaderProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const { addPrefix } = usePrefixedRouting();
  const { closeDrawer } = useDrawers();
  const { isMobile } = useIsMobile();

  return (
    <NotificationHeaderStyled>
      <LayoutRightHeaderTitleStyled className="DrawerHeaderTitle">
        {t("notification.plural")}
      </LayoutRightHeaderTitleStyled>
      {!isMobile && <NotificationStats />}

      <Link
        className="NotificationHeader-MoreLink"
        to={addPrefix(RoutePaths.NOTIFICATIONS)}
      >
        <MuiButton
          className="NotificationMore"
          muiVariant="text"
          endIcon={<PIC.Lauch height={16} />}
          onClick={() => closeDrawer(DrawerType.Notifications)}
        >
          {t("notification.MORE")}
        </MuiButton>
      </Link>
      <DrawerCloseIconButton onCloseDrawer={onClose} />
    </NotificationHeaderStyled>
  );
};
